import React, { useState, useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Helpers from '../utility/Helpers';
import FooterContact from './../common/FooterContact';
import { useNavigate } from 'react-router-dom';
import { GetSessionData, GetKeyResults } from '../services/Service';
import NavigationMenu from '../NavigationMenu';
import {
  Chart as ChartJS,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { PolarArea, Line } from 'react-chartjs-2';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import 'chart.js/auto';
ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend);

function ScoreResult(props) {
  const navigate = useNavigate();
  const [questionList, setQuestionList] = React.useState([]);
  const [sessionDate, setSessionDate] = React.useState('');
  const [scoreResult, setScoreResult] = React.useState('');
  const [totalScore, setTotalScore] = React.useState(0);
  const [scoreData, setScoreData] = React.useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);

  const [keyResultData, setKeyResultData] = React.useState([]);
  const [keyData, setKeyData] = React.useState({});
  const [markLabelColor, setMarkLabelColor] = React.useState('#ffffff');
  const [modalBGColor, setModalBGColor] = React.useState('#ffffff');
  const [categoryName, setCategoryName] = React.useState('');
  const [categoryImageName, setCategoryImageName] = React.useState('');
  const [open, setOpen] = useState(false);
  const chartRefModal = useRef();

  const style = {
    position: 'absolute',
    top: '75px',
    left: '50%',
    transform: 'translate(-50%, 0)',
    width: '100%',
    maxWidth: '500px',
    bgcolor: modalBGColor,
    border: '0px solid #000',
    boxShadow: 12,
    //boxShadow: '0px 0px 0px rgba(0, 0, 0, 0)', // Reduced drop shadow
    p: 0, //padding 0px 1=8px
    //overflow: 'auto',
    //overflowY: 'scroll',
    maxHeight: 'calc(100vh - 75px)', // Set the maximum height
    //scrollbarWidth: 'none', // For Firefox
    //'-ms-overflow-style': 'none', // For Internet Explorer and Edge
  };

  useEffect(() => {
    if (questionList.length < 1)
      if (sessionStorage.getItem('wheelsessionid') !== null) {
        GetSessionData(parseInt(sessionStorage.getItem('wheelsessionid')))
          .then((sres) => {
            //parseInt(sessionStorage.getItem('wheelsessionid'))
            setQuestionList(sres.data.questionList);
            setSessionDate(sres.data.sessionDate);
            setTotalScore(sres.data.totalScore);
            setScoreResult(sres.data.scoreResult);
            //map category wheel score data
            const scores = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            scores[0] = sres.data.questionList[3].scored;
            scores[1] = sres.data.questionList[5].scored;
            scores[2] = sres.data.questionList[9].scored;
            scores[3] = sres.data.questionList[2].scored;
            scores[4] = sres.data.questionList[4].scored;
            scores[5] = sres.data.questionList[8].scored;
            scores[6] = sres.data.questionList[6].scored;
            scores[7] = sres.data.questionList[1].scored;
            scores[8] = sres.data.questionList[0].scored;
            scores[9] = sres.data.questionList[7].scored;
            setScoreData(scores);

            GetKeyResults(0)
              .then((res) => {
                setKeyResultData(res.data);
              })
              .catch((error) => {
                Helpers.handleError(error);
              });
          })
          .catch((error) => {
            Helpers.handleError(error);
            navigate('/login');
          });
      }
    window.scrollTo(0, 0);
  }, [questionList, totalScore, scoreData, navigate]);

  ////Key Line Charts
  const handleClose = () => {
    setMarkLabelColor('#ffffff');
    setOpen(false);
  };
  const handleOpen = (catid) => {
    if (keyResultData.length > 0) {
      if (catid === 3 || catid === 4) {
        setMarkLabelColor('#5F5D5B');
      }

      let catData = [null];
      let dateLabels = [''];
      let kdata = keyResultData.find((item) => item.categoryId === catid);
      setModalBGColor(kdata.colorCode);
      setCategoryName(kdata.name);
      setCategoryImageName(backgroundPictures[catid - 1]);
      for (let i = 0; i < kdata.dateScores.length; i++) {
        dateLabels.push(kdata.dateScores[i].date);
        catData.push(kdata.dateScores[i].score);
      }
      dateLabels.push('');

      let keydataset = [
        {
          data: catData,
          fill: false,
          borderColor: 'rgb(255, 255, 255)',
          borderWidth: 3,
          pointBackgroundColor: 'rgb(88, 88, 90)',
          pointBorderColor: 'rgba(255,255,255,1)',
          pointBorderWidth: 3,
          pointRadius: 12,
          pointHoverRadius: 15,
        },
      ];
      let keychartdata = { labels: dateLabels, datasets: keydataset };
      setKeyData(keychartdata);
      setOpen(true);
    }
  };
  const options = {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 0.9,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        suggestedMin: 0,
        suggestedMax: 11,
        beginAtZero: true,
        border: {
          width: 3,
          color: '#ffffff',
        },
        grid: {
          display: false,
          drawBorder: true,
          borderColor: 'rgb(255, 255, 255)',
          color: 'rgb(255, 255, 255)',
          lineWidth: 2,
        },
        ticks: {
          display: false,
        },
      },
      x: {
        //   afterFit: (scale) => {
        //     scale.height = 120;
        // },
        afterBuildTicks: (axis) => {
          if (axis.ticks && axis.ticks.length > 1) {
            axis.ticks.pop(); // Remove the last tick
            axis.ticks = axis.ticks.slice(1);
          }
        },
        border: {
          width: 3,
          color: '#ffffff',
        },
        grid: {
          drawOnChartArea: false,
          color: 'rgb(255, 255, 255)',
          lineWidth: 3,
          tickLength: 20,
        },
        ticks: {
          padding: 10,
          length: 20,
          fontColor: 'rgb(255, 255, 255)',
          color: markLabelColor, ////change color of label
          font: {
            size: 18,
          },
          callback: function (value) {
            return this.getLabelForValue(value);
          },
          maxRotation: 90,
          minRotation: 90,
        },
      },
    },
  };
  const backgroundPictures = [
    'physical-health-image.png',
    'mental-health-image.png',
    'family-image.png',
    'social-relationship-image.png',
    'fulfilment-image.png',
    'environment-image.png',
    'career-business-aspiration-image.png',
    'financial-status-image.png',
    'decision-making-image.png',
    'sustainability-image.png',
  ];
  const exportPDFModal = () => {
    const input = chartRefModal.current;
    const excludedElements = input.querySelectorAll('.exclude-from-pdf');
    excludedElements.forEach((el) => (el.style.display = 'none'));
    html2canvas(input, {
      scrollX: 0,
      scrollY: -window.scrollY,
      windowWidth: document.documentElement.scrollWidth,
      windowHeight: document.documentElement.scrollHeight,
    })
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', [canvas.width, canvas.height]);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save(categoryName + '.pdf');
      })
      .then(() => {
        // Restore excluded elements
        excludedElements.forEach((el) => (el.style.display = ''));
      });
  };

  ////////

  const data = {
    //database category and color order is not matched looking, that's why hardcoded. Can be work on it
    labels: [
      'Physical Health',
      'Mental Health',
      'Family',
      'Social Relationship',
      'Fulfilment',
      'Environment',
      'Career & Business Aspirations',
      'Financial Status',
      'Decision Making',
      'Sustainability',
    ],
    datasets: [
      {
        label: ' Score ',
        data: scoreData,
        backgroundColor: [
          //CategoryIndex>WheelItemIndex
          '#7d9cc1', //4 3>0
          '#b16d95', //6 5>1
          '#f5ca77', //10 9>2
          '#a9ddf4', //3 2>3
          '#f0a741', //5 4>4
          '#75a188', //9 8>5
          '#e26f8e', //7 6>6
          '#4080a0', //2 1>7
          '#ee8d72', //1 0>8
          '#9bc473', //8 7>9
        ],
        borderWidth: 3,
      },
    ],
  };
  const chartOptions = {
    plugins: {
      legend: {
        display: false,
        position: 'bottom',
        labels: {
          usePointStyle: false,
        },
      },
    },
    scales: {
      r: {
        grid: {
          display: true,
        },
        ticks: {
          display: true,
          color: 'rgba(0, 0, 0, 0)',
          backdropColor: 'rgba(0, 0, 0, 0)',
        },
      },
    },
    onClick: function (evt, element) {
      //console.log(data.datasets[0].data[element[0].index]);
      //console.log(data.labels[element[0].index]);
    },
  };

  const createMarkup = (html) => {
    return { __html: html };
  };
  return (
    <Box width="100%" display="flex" justifyContent="center">
      <NavigationMenu pageName={'Wheel Guide'} />
      <Box className="pageContainer2">
        <Box width="100%">
          <Box className="text-Section-black">
            <Typography
              sx={{
                fontWeight: '500',
                fontSize: '18px',
                fontFamily: 'Quicksand',
                paddingTop: '50px',
              }}
            >
              The scores from each element of your wellbeing are combined to
              create YOUR Wellbeing Wheel for: {sessionDate}
            </Typography>
            <Typography
              sx={{
                fontWeight: '500',
                fontSize: '18px',
                textTransform: 'uppercase',
                fontFamily: 'Quicksand',
                paddingTop: '20px',
                paddingRight: '10px',
              }}
            >
              TAP one of the elements BELOW to view your scores over time.
            </Typography>
          </Box>

          <Box width="100%" paddingBottom="30px"></Box>
          <Box
            paddingBottom="30px"
            width="100%"
            display="flex"
            justifyContent="center"
          >
            <Box
              width="80%"
              display="flex"
              justifyContent="center"
              sx={{ maxWidth: '400px', maxHeight: '400px' }}
            >
              <PolarArea data={data} options={chartOptions} />
            </Box>
          </Box>
        </Box>
        <Box
          width="100%"
          sx={{
            paddingLeft: '20px',
            paddingRight: '20px',
            paddingBottom: '10px',
            backgroundColor: '#fff',
          }}
        >
          <Box
            width="100%"
            display="flex"
            justifyContent="center"
            sx={{ paddingTop: '20px', paddingBottom: '30px' }}
          >
            <Box
              width="100%"
              display="flex"
              justifyContent="center"
              sx={{
                backgroundSize: '100% 100%',
                backgroundRepeat: 'no-repeat',
                position: 'relative',
                width: '100%',
                height: '65px',
                maxWidth: '400px',
                backgroundImage: `url(${process.env.PUBLIC_URL}/images/score-bg.png)`,
              }}
              alt="Org Image"
              src={process.env.PUBLIC_URL + '/images/score-bg.png'}
            >
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '22px',
                  color: 'white',
                  position: 'absolute',
                  top: '49%',
                  msTransform: 'translateY(-49%)',
                  transform: 'translateY(-49%)',
                }}
              >
                TOTAL SCORE: {totalScore}
              </Typography>
            </Box>
          </Box>
          <Box width="100%">
            <Typography
              sx={{
                fontWeight: '500',
                fontFamily: 'Quicksand',
                fontSize: '18px',
              }}
            >
              WHAT DOES MY SCORE MEAN:
            </Typography>
            <Box
              sx={{
                fontWeight: '500',
                fontFamily: 'Quicksand',
                fontSize: '18px',
                paddingTop: '5px',
                paddingRight: '10px',
                paddingBottom: '25px',
              }}
            >
              <div dangerouslySetInnerHTML={createMarkup(scoreResult)} />
            </Box>
          </Box>
          <Box width="100%">
            <div className="accordion-2">
              <Accordion
                sx={{
                  backgroundColor: '#fff',
                  color: '#000000',
                  borderTop: '1px solid #ccc',
                  borderBottom: '1px solid #ccc',
                  borderLeft: '0px',
                  borderRight: '0px',
                }}
              >
                <AccordionSummary
                  sx={{
                    flexDirection: 'row-reverse',
                    color: '#000000',
                    borderLeft: '0px',
                    borderRight: '0px',
                  }}
                  expandIcon={<ArrowDownwardIcon sx={{ color: '#000000' }} />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Typography
                    component="span"
                    sx={{
                      fontWeight: '500',
                      fontFamily: 'Quicksand',
                      fontSize: '18px',
                      paddingLeft: '14px',
                    }}
                  >
                    Key
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {questionList.length > 0 && (
                    <>
                      <List sx={{ marginLeft: '10px' }}>
                        {questionList.map((item, index) =>
                          index === 0 ? (
                            <ListItem
                              key={'item' + index}
                              sx={{
                                marginTop: '0px !important',
                                paddingTop: '0px !important',
                              }}
                              onClick={() => handleOpen(item.categoryId)}
                            >
                              <Box
                                display="flex"
                                alignItems="center"
                                sx={{ mb: 0, ml: 2 }}
                              >
                                <Box
                                  sx={{
                                    width: 20,
                                    height: 20,
                                    bgcolor: item.colorCode,
                                    mr: 0,
                                  }}
                                />
                                <Typography
                                  variant="body1"
                                  sx={{ paddingLeft: '10px' }}
                                >
                                  {item.categoryName}
                                </Typography>
                              </Box>
                            </ListItem>
                          ) : (
                            <ListItem
                              key={'item' + index}
                              onClick={() => handleOpen(item.categoryId)}
                            >
                              <Box
                                display="flex"
                                alignItems="center"
                                sx={{ mb: 0, ml: 2 }}
                              >
                                <Box
                                  sx={{
                                    width: 20,
                                    height: 20,
                                    bgcolor: item.colorCode,
                                    mr: 0,
                                  }}
                                />
                                <Typography
                                  variant="body1"
                                  sx={{ paddingLeft: '10px' }}
                                >
                                  {item.categoryName}
                                </Typography>
                              </Box>
                            </ListItem>
                          )
                        )}
                      </List>
                    </>
                  )}
                </AccordionDetails>
              </Accordion>
            </div>
          </Box>
        </Box>

        

        <FooterContact />
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        slotProps={{
          backdrop: {
            // Customize backdrop props here
            sx: { backgroundColor: 'rgba(0, 0, 0, 0)' },
          },
        }}
      >
        <Box width="100%">
          <Box ref={chartRefModal} sx={style}>
            <Box
              width="100%"
              sx={{
                overflowY: 'scroll',
                maxHeight: 'calc(100vh - 80px)',
                scrollbarWidth: 'none',
                '-ms-overflow-style': 'none',
              }}
            >
              <Box
                width="100%"
                display="flex"
                justifyContent="space-between !important"
                paddingTop="5px"
              >
                <Box sx={{ maxWidth: '200px' }}>
                  <Button onClick={handleClose} sx={{ height: '50px' }}>
                    {/* <span className="exclude-from-pdf" style={{fontWeight:'400', fontFamily: 'Quicksand', fontSize:"36px", color:markLabelColor}}>X</span> */}
                    <CloseIcon
                      className="exclude-from-pdf"
                      sx={{
                        fontSize: '44px !important',
                        color: markLabelColor,
                      }}
                    />
                  </Button>
                  <Typography
                    sx={{
                      fontWeight: '400',
                      textTransform: 'uppercase',
                      fontFamily: 'Quicksand',
                      fontSize: '18px',
                      color: markLabelColor,
                      paddingLeft: '16px',
                    }}
                  >
                    {categoryName}
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: '400',
                      fontFamily: 'Quicksand',
                      fontSize: '26px',
                      color: markLabelColor,
                      paddingLeft: '16px',
                    }}
                  >
                    OVERVIEW
                  </Typography>
                </Box>

                <Box
                  component="img"
                  sx={{ display: { xs: 'none', sm: 'block' } }}
                  alt="Org Image"
                  src={process.env.PUBLIC_URL + '/images/blank.png'}
                />

                <Box
                  component="img"
                  sx={{ display: 'flex', height: '130px', paddingTop: '20px' }}
                  alt="Org Image"
                  src={process.env.PUBLIC_URL + '/images/' + categoryImageName}
                />
              </Box>

              <Line data={keyData} options={options} />

              <Box
                width="100%"
                display="flex"
                justifyContent="center"
                sx={{ paddingTop: '50px', paddingBottom: '40px' }}
              >
                <Box
                  className="exclude-from-pdf"
                  component="img"
                  justifyContent="center"
                  sx={{
                    paddingLeft: '20px',
                    paddingRight: '20px',
                    width: '100%',
                    maxWidth: '400px',
                    display: 'none',
                  }}
                  alt="Org Image"
                  src={process.env.PUBLIC_URL + '/images/download-button.png'}
                  onClick={exportPDFModal}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
export default ScoreResult;
